import { type PropsWithChildren, forwardRef } from "react";

import type { CustomToastProps, ToastType } from "./CustomToast.types";
import { toast } from "sonner";
import { cn } from "$/lib/utils/functions/misc.functions";
import { InfoIcon } from "$/lib/icons/InfoIcon";
import { SuccessIcon } from "$/lib/icons/SuccessIcon";
import { WarningIcon } from "$/lib/icons/WarningIcon";
import CloseIcon from "$/lib/icons/CloseIcon";

const Icons: {
  [key in ToastType]: JSX.Element;
} = {
  info: <InfoIcon />,
  success: <SuccessIcon />,
  warning: <WarningIcon />,
  error: <WarningIcon />,
};

const CustomToast = forwardRef<
  HTMLDivElement,
  PropsWithChildren<CustomToastProps>
>(({ message, type }, forwardedRef) => {
  return (
    <div
      ref={forwardedRef}
      className={cn(
        "lg:w-90 flex flex-row items-center justify-between rounded-lg px-5 py-2 text-white sm:w-80 md:w-80",
        {
          "bg-primary": type === "success",
          "bg-neutral-600": type === "info",
          "bg-warning": type === "warning",
          "bg-danger": type === "error",
        },
      )}
    >
      <div className="flex flex-row items-center justify-center gap-x-2">
        <div>{Icons[type]}</div>
        <p>{message}</p>
      </div>

      <button onClick={() => toast.dismiss()}>
        <CloseIcon color="white" />
      </button>
    </div>
  );
});

CustomToast.displayName = "CustomToast";

export default CustomToast;
